interface LoadingStateProps {
    message?: string;
}

export const LoadingState = ({ message = 'Cargando...' }: LoadingStateProps) => {
    return (
        <div className="flex items-center justify-center py-12">
            <div className="flex flex-col items-center gap-4">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                <p className="text-sm text-muted-foreground">{message}</p>
            </div>
        </div>
    );
};

